<div class="overview-by-customer-page">
    <ng-container>
        <div *ngIf="!isMobile" class="white-section">
            <div class="credit-section page-container container-fluid">
                <p class="over-limit-label" *ngIf="relationshipInformation?.creditLimitAmountOver">
                    <ng-container i18n="Part 1/2 of: 'You are {number} over your credit limit.'"
                        >You are
                    </ng-container>
                    {{ relationshipInformation?.creditLimitAmountOver | currency }}
                    <ng-container i18n="Part 2/2 of: 'You are {number} over your credit limit.'">
                        over your credit limit.</ng-container
                    >
                </p>
                <lsq-progress-bar
                    [value]="relationshipInformation?.creditLimitPercentUsed"
                    [dangerAboveThreshold]="100"
                    [headLabel]="creditLimitCopy"
                    [tailLabel]="
                        (relationshipInformation?.creditLimit -
                            relationshipInformation?.creditLimitAvailable +
                            relationshipInformation?.creditLimitAmountOver | currency) + ' Used'
                    "
                >
                </lsq-progress-bar>
                <div class="request-increase-section">
                    <div class="credit-limit">
                        {{ relationshipInformation?.creditLimit | currency }}
                    </div>
                    <div>
                        <div *claim="claim.ViewCustomers">
                            <a
                                [disabled]="relationshipInformation?.isNoBuy"
                                [queryParams]="{ key: debtorKey }"
                                [routerLink]="increaseCreditLimitRouterLink"
                                i18n="
                                    Click this button to request a credit limit increase for a
                                    customer
                                "
                            >
                                Request Credit Limit Increase
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isMobile" class="mobile-credit-section">
            <div class="mobile-credit-section-left">
                <h4 class="font-weight-bold">
                    {{ relationshipInformation?.creditLimit | currency }}
                </h4>
                <p class="text-uppercase">{{ creditLimitCopy }}</p>
            </div>
            <div class="mobile-credit-section-right">
                <h4 class="font-weight-bold">
                    {{
                        relationshipInformation?.creditLimit -
                            relationshipInformation?.creditLimitAvailable | currency
                    }}
                </h4>
                <p class="text-uppercase" i18n="The amount of a debtor's credit currently in use">
                    Credit Used
                </p>
            </div>
        </div>
        <dashboard-overview
            [debtorKey]="debtorKey"
            [accountSnapshotDataSource]="accountSnapshotByRelationshipDataSource"
            [agingOverviewDataSource]="agingOverviewByRelationshipDataSource"
            [metricsDataSource]="metricsDataSource"
        >
        </dashboard-overview>
    </ng-container>
</div>

<ng-template #bannerContentTemplate let-relationshipInformation="relationshipInformation">
    <div class="customer-overview-banner-content">
        <!-- TODO(dmayer): The data being provided from the endpoint isn't trusted, so temporarily removing. -->
        <!-- <popover-content #dbaPopover>
            <div *ngFor="let dbaName of relationshipInformation?.debtorDbas">
                {{ dbaName }}
            </div>
        </popover-content>
        <lsq-icon *ngIf="relationshipInformation?.debtorDbas?.length"
            class="customer-overview-banner-company-details-popover"
            [type]="icons.CircleInfo"
            [color]="color.Gray"
            [popover]="dbaPopover"
            [popoverPlacement]="placement.Right">
        </lsq-icon> -->
        <lsq-ineligible-tag
            *ngIf="relationshipInformation?.isNoBuy"
            class="customer-overview-banner-company-details-popover"
        >
        </lsq-ineligible-tag>
        <div class="customer-overview-banner-divider"></div>
        <div class="customer-overview-banner-company-info">
            <lsq-address [address]="relationshipInformation?.address"></lsq-address>
        </div>
    </div>
</ng-template>
